/* This code snippet is provided by Qualtrics, slightly edited to accept different zone ids */
/* Taken from: https://github.expedia.biz/Brand-Expedia/shopping-pwa/blob/master/src/common/components/common/header/qualtrics-snippet.ts */
(() => {
  module.exports = {
    qualtricsInsert: (zoneId: string) => {
      let QSI;

      if (typeof QSI === "undefined") {
        QSI = {} as any;
        QSI.config = {
          interceptId: false, // The id of the intercept you want to target (optional)
          zoneId, // The id of the zone you want to target
          brandId: "expediainc", // The id of the brand containing the zone or intercept you are targeting
          editing: false, // Boolean value describing if you want to target the editing revision
          sampleType: "pageview", // Client sampling 'visitor' for visitor sampling or 'pageview' for page view sampling
          sampleRate: 100, // Integer number from 0-100 indicating the sample rate. Set to 100 to disable sampling
        };
      }

      (() => {
        /* istanbul ignore next */
        const CodeInserter = function (rate: number, type: string, cookieName: string, url: string) {
          this.get = (name: string) => {
            const e = `${name}=`;
            const ca = document.cookie.split(";");
            for (let i = 0, ilen = ca.length; i < ilen; i++) {
              let c = ca[i];
              while (c.charAt(0) === " ") {
                c = c.substring(1, c.length);
              }
              if (c.indexOf(e) === 0) {
                return c.substring(e.length, c.length);
              }
            }

            return null;
          };
          this.set = (name: string, value: string) => {
            const expiresTime = new Date();
            expiresTime.setTime(expiresTime.getTime() + 7 * 86400000);
            // @ts-ignore
            const expiresString = `; expires=${expiresTime.toGMTString()}`;
            document.cookie = `${name}=${value}${expiresString}; path=/; `;
          };
          this.check = function () {
            let cookieValue = this.get(cookieName);
            if (!cookieValue) {
              cookieValue = [type, rate, 0];
              if (rate !== 100) {
                if (type === "v") {
                  rate = Math.random() >= rate / 100 ? 0 : 100;
                }
                cookieValue = [type, rate, 0];
                this.set(cookieName, cookieValue.join(":"));
              } else {
                return true;
              }
            } else {
              cookieValue = cookieValue.split(":");
            }
            const percentage = cookieValue[1];
            if (percentage === 100) {
              return true;
            }
            switch (cookieValue[0]) {
              case "v":
                return false;
              case "r":
                const chk = cookieValue[2] % Math.floor(100 / percentage);
                cookieValue[2]++;
                this.set(cookieName, cookieValue.join(":"));

                return !chk;
            }

            return true;
          };
          this.go = function () {
            if (!this.check()) {
              return;
            }
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.src = `${url}&t=${new Date().getTime()}`;
            if (document.body) {
              document.body.appendChild(script);
            }
          };
          this.start = function () {
            if (window.addEventListener) {
              window.addEventListener(
                "load",
                () => {
                  this.go();
                },
                false
              );
            } else if (window["attachEvent"]) {
              window["attachEvent"]("onload", () => {
                this.go();
              });
            }
          };
        };
        try {
          if (QSI.config.zoneId) {
            const param = QSI.config.interceptId ? "Q_SIID" : "Q_ZID";
            let url = `siteintercept.qualtrics.com/WRSiteInterceptEngine/?${param}=${
              QSI.config.interceptId || QSI.config.zoneId
            }`;
            url = `//${QSI.config.zoneId.toLowerCase().replace("_", "")}-${QSI.config.brandId.toLowerCase()}.${url}`;
            url = `${url}&Q_LOC=${encodeURIComponent(window.location.href)}`;
            if (QSI.config.editing) {
              url = `${url}&Q_VERSION=0`;
            }
            let sampleType = "v";
            if (QSI.config.sampleType === "pageview") {
              sampleType = "r";
            }
            // @ts-ignore
            const codeInserter = new CodeInserter(
              QSI.config.sampleRate === 0 ? 0 : QSI.config.sampleRate || 100,
              sampleType,
              `QSI_S_${QSI.config.interceptId || QSI.config.zoneId}`,
              url
            );
            codeInserter.start();
          }
        } catch (e) {
          throw e;
        }
      })();
    },
  };
})();
